import React from "react";
import { Trash2, CircleFadingPlus, Building2 } from "lucide-react";
import "../../../styles/kanbans/job-kanban-card.css";

export type JobKanbanCardProps = {
  id?: string;
  title: string;
  company: string;
  age?: string;
  logoUrl?: string;
  accent?: string;
  onDeleteClick?: () => void;
  onClick?: () => void;
  className?: string;
  isDragging?: boolean;
  /** Wiring supplied by DraggableJobCard; absent when rendered in a DragOverlay. */
  innerRef?: (node: HTMLElement | null) => void;
  dragAttributes?: React.HTMLAttributes<HTMLElement>;
  dragListeners?: Record<string, Function> | undefined;
  style?: React.CSSProperties;
};

export default function JobKanbanCard({
  id,
  title,
  company,
  age,
  logoUrl,
  accent = "#D1D5DB",
  onDeleteClick,
  onClick,
  className,
  isDragging = false,
  innerRef,
  dragAttributes,
  dragListeners,
  style,
}: JobKanbanCardProps) {
  return (
    <article
      ref={innerRef}
      style={style}
      className={`jkCard ${className ?? ""} ${isDragging ? "jkCard--dragging" : ""}`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      {...dragAttributes}
      {...dragListeners}
    >
      <span
        className="jkCard__accent"
        style={{ background: accent }}
        aria-hidden
      />

      <div className="jkCard__content">
        <button
          className="jkCard__delete"
          aria-label="Delete"
          onClick={(e) => {
            e.stopPropagation();
            onDeleteClick?.();
          }}
          type="button"
        >
          <Trash2 size={14} />
        </button>

        <h3 className="jkCard__title">{title}</h3>

        <div className="jkCard__meta">
          <div className="jkCard__company">
            <div className="jkCard__logoWrap" aria-hidden>
              {logoUrl ? (
                <img className="jkCard__logo" src={logoUrl} alt="" />
              ) : (
                <div className="jkCard__logoPH">
                  <Building2 size={18} />
                </div>
              )}
            </div>
            <span className="jkCard__companyName">{company}</span>
          </div>

          <div className="jkCard__rhs">
            {age && <span className="jkCard__age">{age}</span>}
            <div className="jkCard__plus" aria-hidden>
              <CircleFadingPlus size={16} />
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}